export function getDomainWithoutQueryParams(inputUrl) {
    try {
        const parsedUrl = new URL(inputUrl);
        return `${parsedUrl.origin}${parsedUrl.pathname}`;
    }
    catch (error) {
        console.error('Invalid URL:', error);
        return undefined;
    }
}
